import React, { useRef, useState } from 'react';
import Plaque from './Plaque';
import './Performances.css';

function Performances({ data = [], artistBios, plaqueRefs }) {
    const [collageLoaded, setCollageLoaded] = useState(false);
    const currentlyPlayingVideo = useRef(null);
    
    const handleVideoPlay = (currentVideo) => {
        document.querySelectorAll('video').forEach((video) => {
            if (video !== currentVideo) video.pause();
        });
    };

    return (
        <div>            
            <div 
                className="collage-wrapper"
                style={{ position: 'relative' }}
                ref={(el) => (plaqueRefs.current[-1] = el)}
            >
                {!collageLoaded && (
                    <div className="spinner-wrapper">
                        <div className="spinner" />
                    </div>
                )}
                <picture>
                    <source
                        media="(max-width: 768px)"
                        srcSet="/collages/performances_collage_mobile_result.webp"
                    />
                    <img
                        className="performancesTiles"
                        alt="performance-tiles"
                        loading="lazy"
                        src="/collages/performances_collage_result.webp"
                        onLoad={() => setCollageLoaded(true)}
                    />
                </picture>
            </div>

            {data.map((piece, index) => (
                <div
                    key={index}
                    className="art-piece"
                    ref={(el) => (plaqueRefs.current[index] = el)}
                >
                    <Plaque piece={piece} artistBios={artistBios} onVideoPlay={handleVideoPlay} role="performer" />
                </div>
            ))}
        </div>
    )
}

export default Performances;